import { combineReducers } from 'redux';

const newPropertyFromScratchReducer =
  function (state = {}, action) {
    switch (action.type) {
    case 'change_address': {
      return { ...state, address: action.address };
    }
    case 'change_city': {
      return { ...state, city: action.city };
    }
    case 'change_country': {
      return { ...state, country: action.country };
    }
    case 'change_state': {
      return { ...state, state: action.state };
    }
    case 'change_zip': {
      return { ...state, zip: action.zip };
    }
    case 'change_county': {
      return { ...state, county: action.county };
    }
    case 'change_sale_or_lease': {
      return { ...state, sale_or_lease: action.sale_or_lease };
    }
    case 'change_property_type_id': {
      return { ...state, property_type_id: action.property_type_id };
    }
    case 'change_generate_sale_description': {
      return { ...state, generate_sale_description: action.generate_sale_description };
    }
    case 'change_generate_sale_bullets': {
      return { ...state, generate_sale_bullets: action.generate_sale_bullets };
    }
    case 'change_generate_lease_description': {
      return { ...state, generate_lease_description: action.generate_lease_description };
    }
    case 'change_generate_lease_bullets': {
      return { ...state, generate_lease_bullets: action.generate_lease_bullets };
    }
    default: {
      return {
        zip: '', 
        state: '', 
        city: '', 
        address: '',
        generate_sale_description: false,
        generate_sale_bullets: false,
        generate_lease_description: false,
        generate_lease_bullets: false,
        ...state
      };
    }
    }
  };

export default combineReducers({
  brokerSelectOptions: (state = []) => state, // readonly
  propertyTypes: (state = {}) => state, // readonly
  newPropertyFromScratchLocation: newPropertyFromScratchReducer
});
